import { render } from "./EventCard.vue?vue&type=template&id=e3d652a8&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e3d652a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e3d652a8"

export default script